import { useQueryApi } from "api/hooks.ts";
import { partnerApi } from "api/Partner/api.ts";

import GetPartnersRequest = App.Http.Requests.Partner.GetPartnersRequest;
import GetPartnersResponse = App.Http.Responses.Partner.GetPartnersResponse;
import GetPartnerResponse = App.Http.Responses.Partner.GetPartnerResponse;
import GetPartnerInviteInfoResponse = App.Http.Responses.Partner.GetPartnerInviteInfoResponse;

// Hook to get paginated list of partners
export const useGetPartnersQuery = (request: GetPartnersRequest, options = {}) => {
    return useQueryApi<GetPartnersResponse>({
        queryKey: ["getPartners", { ...request }],
        queryFn: () => partnerApi.index(request),
        ...options,
    });
};

// Hook to get a specific partner
export const useGetPartnerQuery = (partnerId: string, options = {}) => {
    const request = { filter: { include: "catalogCategories,websites,catalogWebTypes" } };

    return useQueryApi<GetPartnerResponse>({
        queryKey: ["getPartner", partnerId, request],
        queryFn: () => partnerApi.show(partnerId, request),
        ...options,
    });
};

// Hook to get a partner's invite info (for the "invite from partner catalog" drawer)
export const useGetPartnerInviteInfoQuery = (partnerId: string, options = {}) => {
    return useQueryApi<GetPartnerInviteInfoResponse>({
        queryKey: ["getPartnerInviteInfo", partnerId],
        queryFn: () => partnerApi.inviteInfo(partnerId),
        ...options,
    });
};
